module.exports = __webpack_public_path__ + "img/netvendor_logo.82028666.png";